/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Describes the overall scope resp. level of services.   (bipro-produktmodell::Paket)     * `Basic`   * `Classic`   * `Premium`   * `Partner`   * `ProClassic`   * `ProPremium`   * `ProCar`   * `PlusBonus`
 */
export const MotorVehiclePackage = {
  Basic: 'Basic',
  Classic: 'Classic',
  Premium: 'Premium',
  Partner: 'Partner',
  ProClassic: 'ProClassic',
  ProPremium: 'ProPremium',
  ProCar: 'ProCar',
  PlusBonus: 'PlusBonus',
} as const;
export type MotorVehiclePackage = (typeof MotorVehiclePackage)[keyof typeof MotorVehiclePackage];
